module.exports = __webpack_public_path__ + "img/automation.5c870735.png";